module.exports = __webpack_public_path__ + "assets/img/thumb-NuMobile-Brand-Video.6e9f7261.jpg";